<template>
  <q-dialog 
    :visible="dialogVisible" 
    title="表格设置" 
    width="40%"
    :innerScroll="false"
    :showFooter="false"
    @close="closeTableSet"
  >
    <el-table
      ref="table"
      max-height="400px"
      border
      :data="tableDataSet"
      class="draggable-table"
      :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
      row-key="columnName"
    >
      <el-table-column prop="displayName" label="列标题" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="displayWidth" label="列宽(px)">
        <template slot-scope="scope">
          <el-input v-model="scope.row[scope.column.property]" size="mini" @input="input(scope)" autosize></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="freezeLeft" label="列左冻结">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row[scope.column.property]" @change="freezeChange(scope.row, 1)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="freezeRight" label="列右冻结">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row[scope.column.property]" @change="freezeChange(scope.row, 2)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="isShow" label="是否隐藏">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row[scope.column.property]" @change="freezeChange(scope.row, 3)"></el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; padding-top: 30px;">
      <el-button  @click="closeTableSet">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
  </q-dialog>
</template>

<script>
// import Sortable from "sortablejs"; //表格拖拽排序
export default {
  model: {
    prop: "visible",
    event: "input",
  },
  name: "customTable",
  props: ["tableDataSet", "visible"],
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {
    this.dialogVisible = this.visible;
  },
  mounted() {
    //表格拖拽排序
    // this.$nextTick((_) => {
    //   this.rowDrop();
    // });
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout((_) => {
        this.$emit("input", false);
      }, 200);
    },
    input(scope) {
      scope.row[scope.column.property] =
        scope.row[scope.column.property] == 0 ? "" : scope.row[scope.column.property].replace(/[^\d]/g, "");
    },
    freezeChange(row, type) {
      if (type == 1) {
        row.freezeRight = false;
        row.isShow = false;
      } else if (type == 2) {
        row.freezeLeft = false;
        row.isShow = false;
      } else if (type == 3) {
        row.isShow = row.isShow;
        row.freezeLeft = false;
        row.freezeRight = false;
      }
    },
    closeTableSet() {
      this.dialogVisible = false;
      this.$emit("closeAddForm", false);
    },
    confirm() {
      this.$emit("confirm");
    },
    //行拖拽
    // rowDrop() {
    //   const tbody = document.querySelector(".draggable-table .el-table__body-wrapper tbody");
    //   const _this = this;
    //   this.sortableInstance = Sortable.create(tbody, {
    //     draggable: ".el-table__row", // 设置可拖拽行的类名(el-table自带的类名)
    //     onEnd({ newIndex, oldIndex }) {
    //       // 拖拽结束触发的事件
    //       const currentDragRow = _this.tableDataSet.splice(oldIndex, 1)[0]; // 当前拖拽行
    //       _this.tableDataSet.splice(newIndex, 0, currentDragRow);
    //     },
    //   });
    // },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--mini .el-input__inner
  text-align: center
>>> .el-dialog 
  margin-top 50px !important
>>> .el-dialog__body
    padding 20px 0px 20px 15px !important
</style>
